function toggleIsTruncatedText(button) {
  const richTextDiv = button.previousElementSibling;
  if (!richTextDiv) return;

  const isTruncated = richTextDiv.classList.contains('rich-text__truncate');

  if (isTruncated) {
    richTextDiv.classList.remove('rich-text__truncate');
    button.innerText = 'Read Less';
  } else {
    richTextDiv.classList.add('rich-text__truncate');
    button.innerText = 'Read More';
  }
}